import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RootState } from "../../store";
import { roleHomePath } from "../../utils/role-home";
import Authorization from "./Authorization";

interface AuthPageProps {
  mode: "signin" | "signup";
}

/**
 * Standalone auth page at /login or /signup.
 * Redirects to returnTo if present, otherwise to the user's role home.
 */
const AuthPage: React.FC<AuthPageProps> = ({ mode }) => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.session);
  const isImpersonating = useSelector((state: RootState) => state.impersonation.isImpersonating);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (isAuthenticated) {
      // An explicit returnTo wins; otherwise send the user to their own home
      // rather than /dashboard, which dropped admins on the learner view.
      const returnTo = searchParams.get("returnTo") || roleHomePath(user?.role, isImpersonating);
      navigate(returnTo, { replace: true });
    }
  }, [isAuthenticated, user?.role, isImpersonating, navigate, searchParams]);

  if (isAuthenticated) return null;

  return <Authorization initialView={mode} />;
};

export default AuthPage;
